'use strict';

import React from 'react';
import { Card, Form, Button } from 'react-bootstrap';
const uuid = require('uuid');

const Globals = require('../../../../app/globals');
const SiteConfigStore = require('../../stores/SiteConfigStore');
const SiteConfigActions = require('../../actions/SiteConfigActions');
import ErrorBox from '../common/ErrorBox';
import LoadingMainContent from '../loading/LoadingMainContent';
import Tooltip from '../common/Tooltip';
import MessageBar from '../common/MessageBar';
import OrgRoleDropdown from '../common/OrgRoleDropdown';

const propTypes = {};
const defaultProps = {};

// Globals.site_config.DEFAULT_EXAMPLE_PROJECT_NAME

class AdminSiteConfigEditor extends React.Component {
    constructor(props) {
        super(props);

        const siteConfigStoreState = SiteConfigStore.getState();

        this.state = {
            siteConfigStoreState: siteConfigStoreState,
            exampleProjectId: siteConfigStoreState.siteConfig ? siteConfigStoreState.siteConfig.example_project_id : '',
            exampleProjectName: siteConfigStoreState.siteConfig ? siteConfigStoreState.siteConfig.example_project_name : '',
            siteMessage: siteConfigStoreState.siteConfig ? siteConfigStoreState.siteConfig.site_message : '',
            maintenanceMode: siteConfigStoreState.siteConfig ? siteConfigStoreState.siteConfig.maintenance_mode : false,
            registrationOrgId: siteConfigStoreState.siteConfig ? siteConfigStoreState.siteConfig.registration_org_role_id : '',
            registrationOrgRoleToken: siteConfigStoreState.siteConfig ? siteConfigStoreState.siteConfig.registration_org_role_token : '',
            actionId: null,
            error: null
        };

        this.onProjectIdChange = this.onProjectIdChange.bind(this);
        this.onProjectNameChange = this.onProjectNameChange.bind(this);
        this.onSiteMessageChange = this.onSiteMessageChange.bind(this);
        this.updateHandler = this.updateHandler.bind(this);
        this.onMaintenanceModeChange = this.onMaintenanceModeChange.bind(this);
        this.onDefaultOrgIdChange = this.onDefaultOrgIdChange.bind(this);
        this.onDefaultOrgRoleTokenChange = this.onDefaultOrgRoleTokenChange.bind(this);
        this.unsubscribes = [SiteConfigStore.listen(this.onSiteConfigStoreStateChange.bind(this))];
    }

    componentDidMount() {
        SiteConfigActions.getSiteConfig(uuid.v4());
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onProjectIdChange(e) {
        let val = 0;
        if (e.target.value) {
            val = Math.max(parseInt(e.target.value) || 0, 0);
        }

        this.setState({ exampleProjectId: val });
    }

    onProjectNameChange(e) {
        this.setState({ exampleProjectName: e.target.value });
    }

    onSiteMessageChange(e) {
        this.setState({ siteMessage: e.target.value });
    }

    onMaintenanceModeChange(e) {
        this.setState({ maintenanceMode: e.target.checked });
    }

    onDefaultOrgIdChange(e) {
        this.setState({ registrationOrgId: e.target.value });
    }

    onDefaultOrgRoleTokenChange(token) {
        this.setState({ registrationOrgRoleToken: token });
    }

    onSiteConfigStoreStateChange(state) {
        const initNoError = state.siteConfig && !state.action.error;
        let additionalState = {};

        if (state.action.id === this.state.actionId) {
            additionalState = { ...additionalState, actionId: null };
        }

        this.setState({
            siteConfigStoreState: state,
            exampleProjectId: initNoError ? state.siteConfig.example_project_id : this.state.exampleProjectId,
            exampleProjectName: initNoError ? state.siteConfig.example_project_name : this.state.exampleProjectName,
            siteMessage: initNoError ? state.siteConfig.site_message : this.state.siteMessage,
            maintenanceMode: initNoError ? state.siteConfig.maintenance_mode : this.state.maintenanceMode,
            registrationOrgId: initNoError ? state.siteConfig.registration_org_id : this.state.registrationOrgId,
            registrationOrgRoleToken: initNoError ? state.siteConfig.registration_org_role_token : this.state.registrationOrgRoleToken,
            error: state.action.error || null,
            ...additionalState
        });
    }

    updateHandler() {
        const actionId = uuid.v4();
        this.setState({ actionId: actionId });
        SiteConfigActions.updateSiteConfig(actionId, {
            exampleProjectId: this.state.exampleProjectId,
            exampleProjectName: this.state.exampleProjectName,
            registrationOrgId: this.state.registrationOrgId,
            registrationOrgRoleToken: this.state.registrationOrgRoleToken,
            siteMessage: this.state.siteMessage,
            maintenanceMode: this.state.maintenanceMode,
        });
    }

    render() {
        if (!this.state.siteConfigStoreState.initialized) {
            return <LoadingMainContent/>;
        }

        return (
            <div>
                <h2 className="heading-lg">Site Config</h2>
                <Card body bg="light">
                    <ErrorBox error={this.state.error} />
                    <Form>
                        <Form.Group controlId="admin-site-conf-maint-mode">
                            <Form.Check>
                                <Form.Check.Input checked={this.state.maintenanceMode} onChange={this.onMaintenanceModeChange} />
                                <Form.Check.Label className="margin-left-sm">Maintenance Mode <span className="font-size-14px">(Send incoming LTI/Connect requests to maintenance view. Block activity editing.)</span></Form.Check.Label>
                            </Form.Check>
                        </Form.Group>

                        <Form.Group
                        controlId="admin-site-conf-proj-id"
                        >
                            <Form.Label>Example Project ID</Form.Label>
                            <Form.Control
                                aria-label="Example Project ID"
                                value={this.state.exampleProjectId}
                                onChange={this.onProjectIdChange}
                            />
                        </Form.Group>

                        <Form.Group
                        controlId="admin-site-conf-proj-name"
                        >
                            <Form.Label>Example Project Name</Form.Label>
                            <Form.Control
                                aria-label="Example Project Name"
                                value={this.state.exampleProjectName}
                                onChange={this.onProjectNameChange}
                            />
                        </Form.Group>

                        <Form.Group
                        controlId="admin-site-conf-default-org-id"
                        >
                            <Form.Label>Default Registration Organization ID</Form.Label>
                            <Form.Control
                                aria-label="Default Registration Organization ID"
                                value={this.state.registrationOrgId}
                                onChange={this.onDefaultOrgIdChange}
                            />
                        </Form.Group>

                        <Form.Group
                            controlId="admin-site-conf-default-org-role-token"
                        >
                            <Form.Label>Default Registration Organization Role Token</Form.Label>
                            <OrgRoleDropdown
                                id="admin-site-conf-default-org-role-token"
                                className="margin-left-md"
                                selectedRoleToken={this.state.registrationOrgRoleToken}
                                onRoleChange={this.onDefaultOrgRoleTokenChange}
                                includeGuest
                            />
                        </Form.Group>

                        <Form.Group
                        controlId="admin-site-conf-site-message"
                        >
                            <Form.Label>Site Message</Form.Label>
                            <Form.Control
                                aria-label="Site Message"
                                value={this.state.siteMessage}
                                onChange={this.onSiteMessageChange}
                            />
                        </Form.Group>

                        <div>
                            <h3>Site message preview:</h3>
                            <MessageBar className="mzl-cs-announce margin-top-sm margin-bottom-lg">
                                <span dangerouslySetInnerHTML={{__html: this.state.siteMessage}} />
                            </MessageBar>
                        </div>

                        <Button
                            disabled={!!this.state.actionId}
                            onClick={this.updateHandler}
                        >
                            Update
                        </Button>
                    </Form>
                </Card>
            </div>
        );
    }
}

AdminSiteConfigEditor.propTypes = propTypes;
AdminSiteConfigEditor.defaultProps = defaultProps;

export default AdminSiteConfigEditor;